import { render, staticRenderFns } from "./ElectricityConsumptionPage.vue?vue&type=template&id=63eb66a8&scoped=true&"
import script from "./ElectricityConsumptionPage.vue?vue&type=script&lang=js&"
export * from "./ElectricityConsumptionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eb66a8",
  null
  
)

export default component.exports